import {Fragment, useEffect, useState, useContext} from 'react';

import LoginContext from '../../../../../store/login-context';
import classes from './BioIdCode.module.scss';
import BackStep from '../General/BackStep/BackStep';
import Skip from '../Skip/Skip';
import ProgressBar from '../ProgressBar/ProgressBar';

declare function Translate(key: string): string;
declare var _curLang: any;

const BioIdCode = (props) => {
    const ctx = useContext(LoginContext);

    const handleYesClick = () => {
        props.setCurrentScreenStep(ctx.preRegScreenCollection.servicePositions);
        props.AddUserStep(ctx.preRegScreenCollection.servicePositions);
    };

    const handleNoClick = () => {
        props.setCurrentScreenStep(ctx.preRegScreenCollection.pibaNoCode);
        props.AddUserStep(ctx.preRegScreenCollection.pibaNoCode);
    };

    const onBackStepHandler = () => {
        props.prevScreen(); 
    }

    
    return(        
        <Fragment>  
            <ProgressBar pbWidth="85%"/>                     
            <div className={classes.container}>
                <div>
                    <BackStep prevStep = {onBackStepHandler} />
                
                    <div className={`preRegTitleBold ${classes.title}`}>{Translate('N_Login_Bio_ID_Has_Code')}</div>            
                    <div className={`preRegText ${classes.desc}`}>
                        {Translate('N_Login_Bio_ID_Code_Desc')}
                    </div>                            
                    <div className={classes.buttons_container}>
                        <button className={`${classes.btn_no} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_ltr : ''}`} id='btnBioIdCodeNo' onClick={handleNoClick}>
                            <span>{Translate('N_General_No')}</span>                     
                        </button>
                        <button className={classes.btn_yes} id='btnBioIdCodeYes' onClick={handleYesClick}>
                            <span>{Translate('N_General_Yes')}</span>                     
                        </button>
                    </div>
                    <div className={classes.buttons_container_mobile}>
                        <button className={classes.btn_yes} id='btnBioIdCodeYesMobile' onClick={handleYesClick}>
                            <span>{Translate('N_General_Yes')}</span>                     
                        </button>
                        <button className={`${classes.btn_no} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_ltr : ''}`} id='btnBioIdCodeNoMobile' onClick={handleNoClick}>
                            <span>{Translate('N_General_No')}</span>                     
                        </button>
                    </div>
                </div>
                <div className={classes.skip}>
                    <Skip/>
                </div>
            </div>              
        </Fragment>
    )

};
export default BioIdCode;